<template>
  <section class="button-container">
    <h3>Säter Triathlon 2025 är en del av:</h3>

    <div class="button-container__sponsors-container">
      <div class="button-container__sponsor-container">
        <a href="https://www.svenskatriathloncupen.se/">
          <img
            src="../assets/logos/SvenskaTriathloncupen_logo.png"
            alt="Svenska Triathlon Cupen"
          />
        </a>
      </div>
      <!-- <div class="button-container__sponsor-container">
        <a href="https://lokalti.se/"
          ><img src="../assets/logos/RM_olympisk.jpg" alt="Säters Kommun logo"
        /></a>
      </div>
      <div class="button-container__sponsor-container">
        <img src="../assets//logos/SM_olympisk.jpg" alt="SM Olympsik" />
      </div> -->
      <!-- <div class="button-container__sponsor-container">
        <img src="../assets/logos/Tri4Fun_109.jpg" alt="Tri4fun" />
      </div> -->
    </div>

    <!-- <div class="button-container__sponsors-container">
        <div class="button-container__sponsor-container">
          <a href="https://www.sater.se/"><img src="../assets/images/saterkommun.jpg" alt="Säters Kommun logo" /></a>
        </div>
        <div class="button-container__sponsor-container">
          <a href="https://umarasports.com/"><img src="../assets/images/umara.png" alt="Säters Kommun logo" /></a>
        </div>
        <div class="button-container__sponsor-container">
          <a href="https://lokalti.se/"><img src="../assets/images/lokalt.png" alt="Säters Kommun logo" /></a>
        </div>
      </div> -->

    <!-- <router-link to="/registration">
        <div class="button-container__outer">
          <div class="button-container__button">
            <img src="../assets/svg/signup.svg">
          </div>
          <span>Anmälan</span>
        </div>
      </router-link>
      <router-link to="/results">
        <div class="button-container__outer">
          <div class="button-container__button">
            <img src="../assets/svg/finish.svg">
          </div>
          <span>Resultat</span>
        </div>
      </router-link>
      <router-link to="/participant">
        <div class="button-container__outer">
          <div class="button-container__button">
            <img src="../assets/svg/info.svg">
          </div>
          <span>Information</span>
        </div>
      </router-link> -->
  </section>
</template>

<script>
export default {
  name: "SecondaryNav",
};
</script>

<style lang="scss" scoped>
.button-container {
  width: 100%;
  height: auto;
  min-height: 150px;
  // background-color: rgba(204, 229, 253, 0.493);
  box-shadow: 1px 1px 8px #c8c8c8;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 24px;
  box-sizing: border-box;

  h3 {
  }

  &__sponsors-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    // max-height: 60px;
  }

  &__sponsor-container {
    display: flex;
    align-items: center;
    max-height: 60px;
    width: auto;
    cursor: pointer;
    margin: 0 20px;

    img {
      max-width: 100%;
      max-height: 60px;
    }
  }

  a,
  a:visited {
    text-decoration: none;
    color: black;
  }

  &__outer {
    display: flex;
    flex-direction: column;
  }

  &__button {
    height: 60px;
    width: 60px;
    border-radius: 50%;
    border: 1px solid rgb(129, 129, 129);
    margin: 45px auto 10px;
    cursor: pointer;

    img {
      width: 30px;
      margin-top: 15px;
    }
  }

  &__button:hover {
    background-color: rgba(163, 207, 248, 0.493);
  }

  &__button:active {
    background-color: rgba(124, 186, 245, 0.493);
  }

  @media only screen and (max-width: 600px) {
    .button-container {
      padding: 24px;

      &__sponsors-container {
        flex-wrap: wrap;
        gap: 24px;
        padding-bottom: 24px;
      }
    }
  }
}
</style>
